import React from "react";
import { ModulesTableComponent } from "../../ModulesTableComponent";
import useColumnFilter from "../../../hooks/useColumnFilter";
import useGetCityColumns from "../../../hooks/cities/useGetCityColumns";
import useGetModuleColumns from "../../../hooks/modules/useGetModuleColumns";
import useFilteredColumns from "../../../hooks/useFilteredColumns";

export const ModuleListComponent = (props) => {
  const {
    data = { data: [], total: 0 },
    onPaginationChange,
    currentPagination,
    onSelection,
    selectedRowKey,
    onSortChange,
    columnFilter,
    setColumnFilter,
    tableLoading,
  } = props;

  const moduleColumns = useGetModuleColumns();

  const { getColumnFilterProps } = useColumnFilter(
    columnFilter,
    setColumnFilter
  );

  let newCols = useFilteredColumns(moduleColumns, getColumnFilterProps);

  return (
    <>
      <ModulesTableComponent
        data={data}
        onPaginationChange={onPaginationChange}
        onSelection={onSelection}
        selectedRowKey={selectedRowKey}
        tableColumns={newCols || []}
        currentPagination={currentPagination}
        onSortChange={onSortChange}
        tableLoading={tableLoading}
      />
    </>
  );
};
